<template>
  <v-container class="error-page fill-height">
    <v-row class="text-center" justify="center">
      <v-col cols="auto">
        <h1>
          404
        </h1>
        <v-img
          max-width="640"
          max-height="480"
          src="@/assets/404.jpg"
          contain
        />
        <div>
          見つかりませんでした
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'NotFoundError'
}
</script>

<style></style>
